/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';

import { Plan } from '../model/plan';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PlansService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Return the plan detail
     * 
     * @param planId The plan id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlanDetail(planId: number, observe?: 'body', reportProgress?: boolean): Observable<Plan>;
    public getPlanDetail(planId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Plan>>;
    public getPlanDetail(planId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Plan>>;
    public getPlanDetail(planId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling getPlanDetail.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Plan>(`${this.getBasePath()}/api/v1/plans/${encodeURIComponent(String(planId))}`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the plans
     * 
     * @param giftPlanFilter The gift plan filter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlans(giftPlanFilter?: 'All' | 'GiftPlansOnly' | 'NoGiftPlansOnly', observe?: 'body', reportProgress?: boolean): Observable<Array<Plan>>;
    public getPlans(giftPlanFilter?: 'All' | 'GiftPlansOnly' | 'NoGiftPlansOnly', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Plan>>>;
    public getPlans(giftPlanFilter?: 'All' | 'GiftPlansOnly' | 'NoGiftPlansOnly', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Plan>>>;
    public getPlans(giftPlanFilter?: 'All' | 'GiftPlansOnly' | 'NoGiftPlansOnly', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (giftPlanFilter !== undefined && giftPlanFilter !== null) {
            queryParameters = queryParameters.set('giftPlanFilter', <any>giftPlanFilter);
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Plan>>(`${this.getBasePath()}/api/v1/plans`,
            {
                params: queryParameters,
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
